import { render } from "./UiAvatar.vue?vue&type=template&id=517c8547"
import script from "./UiAvatar.vue?vue&type=script&lang=js"
export * from "./UiAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__